import React from "react";
import { boardMembers } from "../data/content";

const paragraphs = [
  "Bursa Trabzonlular Derneği olarak, köklerimizi aldığımız Trabzon'un güçlü kültürünü, kadim değerlerini ve dayanışma ruhunu Bursa'da yaşatmanın büyük onurunu taşıyoruz. Bizim için Trabzon sadece bir şehir değil; aidiyetin, hatıranın, vefanın ve karakterin adıdır. Bursa ise bugün hayat kurduğumuz, emek verdiğimiz, ürettiğimiz ve birlikte geleceğe yürüdüğümüz ortak yuvamızdır. İşte derneğimiz, bu iki güçlü değeri aynı gönülde buluşturan bir birlik çatısıdır.",
  "Bizler geçmişine saygı duyan, köklerini unutmayan, büyüklerinden aldığı mirası geleceğe taşımayı görev bilen bir anlayışın temsilcileriyiz. Trabzon'dan taşıdığımız kültür; çalışkanlığı, dürüstlüğü, mertliği, misafirperverliği ve dayanışmayı içinde barındırır. Bu değerleri Bursa'da en güzel şekilde temsil etmek, yaşatmak ve gelecek nesillere aktarmak en önemli sorumluluklarımızdan biridir.",
  "Derneğimiz, yalnızca hemşehrilerimizin bir araya geldiği bir yer değil; aynı zamanda dostluğun, paylaşmanın, dayanışmanın ve kardeşliğin evidir. Biz kapsayıcı bir anlayışla hareket ediyoruz. Yaşı, mesleği, düşüncesi, hayat tecrübesi ne olursa olsun; gönlünde Trabzon sevgisi taşıyan, birlik ve beraberlik duygusunu önemseyen herkese kapımız da gönlümüz de açıktır. Çünkü biz inanıyoruz ki gerçek güç, farklılıklarımızı zenginlik bilerek aynı çatı altında kenetlenebilmekten doğar.",
  "Özellikle gençlerimiz bizim için çok kıymetlidir. Onların sadece bugünün değil, yarının da taşıyıcıları olduğunun bilincindeyiz. Bu nedenle gençlerimize sahip çıkan, onları kültürel değerleriyle buluşturan, eğitimde, sosyal hayatta ve toplumsal sorumluluk alanlarında destekleyen, yol gösteren bir dernek anlayışını büyütmek istiyoruz. Gençlerimizin köklerinden güç alarak geleceğe güvenle yürümeleri, derneğimizin en önemli hedeflerinden biridir.",
  "Hayat sadece güzel günlerden ibaret değildir. Bu yüzden biz, sevinçte olduğu kadar hüzünde de birlikte olmanın değerine inanıyoruz. İyi günlerde mutluluğu çoğaltan, zor günlerde omuz veren, ihtiyaç anında yanında hissedilen bir dernek olmak istiyoruz. Hemşehrilerimizin ve gönüldaşlarımızın her zaman yanında durmak, onların sevinçlerini ve üzüntülerini samimiyetle paylaşmak bizim için bir görev değil, gönül meselesidir.",
  "Bursa Trabzonlular Derneği olarak hedefimiz; geçmişten aldığı güçle geleceğe umutla bakan, kültürünü korurken çağın gereklerini de yakalayan, birleştiren, kucaklayan ve yol açan bir anlayışı hâkim kılmaktır. Birlik ve beraberliğimizi güçlendirdikçe, birbirimize daha sıkı sarıldıkça ve ortak değerler etrafında kenetlendikçe çok daha güzel çalışmalara hep birlikte imza atacağımıza yürekten inanıyorum.",
  "Bu duygu ve düşüncelerle, derneğimize gönül veren, destek olan ve bu büyük aileye değer katan herkese teşekkür ediyorum.",
];

const BaskanMesajiPage: React.FC = () => {
  const president = boardMembers[0];
  return (
    <div className="min-h-screen bg-bg-page">
      {/* Hero */}
      <div className="w-full py-16 px-6 xl:px-16" style={{ backgroundColor: "#0F172A" }}>
        <div className="max-w-5xl mx-auto text-center">
          <div className="text-brand-gold text-sm font-semibold uppercase tracking-widest mb-3">Kurumsal</div>
          <h1 className="text-3xl md:text-4xl font-bold text-white leading-snug">Başkanın Mesajı</h1>
        </div>
      </div>

      {/* İçerik */}
      <div className="w-full px-6 xl:px-16 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Fotoğraf + Selamlama */}
          <div className="flex items-center gap-5 mb-8">
            <img
              src="/baskan-foto.jpg"
              alt={president.name}
              className="w-20 h-20 rounded-full object-cover flex-shrink-0 shadow-md border-2 border-brand-bordo"
            />
            <div>
              <p className="text-text-primary font-semibold text-lg">
                Kıymetli hemşehrilerim, değerli dostlarımız,
              </p>
              <p className="text-text-muted text-sm mt-1">{president.name} — {president.role}</p>
            </div>
          </div>

          {/* Paragraflar */}
          {paragraphs.map((p, i) => (
            <p key={i} className="text-text-muted leading-relaxed mb-5 text-justify">
              {p}
            </p>
          ))}

          {/* İmza */}
          <p className="text-text-primary font-semibold mt-8">Saygı ve muhabbetlerimle,</p>
          <div className="flex items-center gap-4 mt-4">
            <img
              src="/baskan-foto.jpg"
              alt={president.name}
              className="w-12 h-12 rounded-full object-cover shadow border border-gray-200"
            />
            <div>
              <div className="font-bold text-text-primary">{president.name}</div>
              <div className="text-text-muted text-sm">{president.role}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaskanMesajiPage;
